import { Injectable } from '@angular/core';
import { CreateKaizen, PostResponse, GetResponse,  KaizenState, KaizenForecastAdj, KaizenForecastAdjLive, NotificationDTO } from '../models/Kaizen'
import { Observable, of } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment'
import { PagedResponseKaizen } from '../kaizens/kaizen';
import { PRKaizenMonthlySavingsList } from '../models/kaizen-monthly-savings-list';
import { ActualDTO, PagedResponseActual } from '../models/ActualDTO';
 

@Injectable({
  providedIn: 'root'
})


export class KaizenService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService: MessageService, private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  getKaizen(id: number): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.APIURL + '/Kaizen/' + id, this.httpOptions);
  }

  getKaizenAccountsByKaizenId(id: number): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.APIURL + '/KaizenAccount/GetKaizenAccountsByKaizen/' + id, this.httpOptions);
  }
 
  getKaizenActualsByKaizen(id: number): Observable<PagedResponseActual> {
    return this.http.get<PagedResponseActual>(this.APIURL + '/KaizenActual/GetKaizenActualsByKaizen/' + id, this.httpOptions);
  }
  
  getKaizenCombined(id: number): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.APIURL + '/KaizenCombined/' + id, this.httpOptions);
  }

  getKaizenCombinedByFy(CompanyID: number, lineId: number, shopId: number, finYear: number): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.APIURL + '/KaizenCombined/GetByFy/' + CompanyID + '/' + lineId + '/' + shopId + '/' + finYear, this.httpOptions);
  }

  putCompleteDelete(complete: boolean, kaizenId: number, completionDay: string, completionMonth: string, completionYear: string, reasonForCancellation: string, submitToBpaks:boolean, email: string): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.APIURL + '/KaizenCombined/CompleteDelete/' + complete + '/' + kaizenId + '/' + completionDay + '/' + completionMonth + '/' + completionYear + '/' + reasonForCancellation + '/' + submitToBpaks + '/' + email, this.httpOptions);
  }

  getForecastAdjByKaizenNumbers(kaizenNumbers: string): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.APIURL + '/ForecastAdjustment/GetByKaizenNumbers/' + kaizenNumbers, this.httpOptions);
  }
  postForecastAdj(val: KaizenForecastAdj[]): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.APIURL + '/ForecastAdjustment', val, this.httpOptions);
  }

  getKaizenMonthlySaving(id: number): Observable<PRKaizenMonthlySavingsList> {
    return this.http.get<PRKaizenMonthlySavingsList>(this.APIURL + '/KaizenMonthlySaving/' + id, this.httpOptions);
  }

  getKaizenMonthlySavingByKaizenAccountId(id: number): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.APIURL + '/KaizenMonthlySaving/GetByKaizenAccountId/' + id, this.httpOptions);
  }

  addKaizen(val: CreateKaizen): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.APIURL + '/Kaizen', val, this.httpOptions);
  }

  // addKaizenAccount(val: KaizenAccount): Observable<PostResponse> {
  //   return this.http.post<PostResponse>(this.APIURL + '/KaizenAccount', val, this.httpOptions);
  // }

  addKaizenYokotenable(val: any): number {
    var id: number = 0;
    this.http.post<any>(this.APIURL + '/kaizenYokotenable', val, this.httpOptions).subscribe({
      next: data => { id = data.KaizenYokotenableID; },
      error: error => { console.error('There was an error!', error); }
    })
    return id;
  }

  updateKaizen(val: CreateKaizen): Observable<PostResponse> {
    return this.http.put<PostResponse>(this.APIURL + '/Kaizen', val);
  }

  // updateKaizenAccount(val: KaizenAccount): Observable<PostResponse> {
  //   return this.http.put<PostResponse>(this.APIURL + '/KaizenAccount', val);
  // }

  updateKaizenStatus(val: KaizenState): Observable<PostResponse> {
    return this.http.put<PostResponse>(this.APIURL + '/KaizenCombined', val);
  }
  updateKaizenForecastAdjLive(val: KaizenForecastAdjLive[]): Observable<PostResponse> {
    return this.http.put<PostResponse>(this.APIURL + '/KaizenCombined/UpdateKaizenForecastLive', val, this.httpOptions);
  }
  getReviewKaizen(hidden: Boolean, email:string): Observable<PagedResponseKaizen> {
    return this.http.get<PagedResponseKaizen>(this.APIURL + '/Kaizen/GetReviewKaizens' + '?PageNumber=1&PageSize=55' + '&ShowHidden=' + JSON.stringify(hidden) + '&Email=' + email);
    
  }
  getReviewKaizenPaged(hidden: boolean, email: string, pageNumber: number, pageSize: number, search?: string): Observable<PagedResponseKaizen> {
    let url = `${this.APIURL}/Kaizen/GetReviewKaizens` + `?PageNumber=${pageNumber}` + `&PageSize=${pageSize}` + `&ShowHidden=${hidden}` + `&Email=${email}`;
    return this.http.get<PagedResponseKaizen>(url);
  }
  getNotificationKaizens(hidden: Boolean, email:string): Observable<NotificationDTO> {
    return this.http.get<NotificationDTO>(this.APIURL + '/Kaizen/GetNotificationKaizens' + '?ShowHidden=' + JSON.stringify(hidden) + '&Email=' + email);
  }

  searchKaizens(criteria: string, hidden: Boolean, email: string): Observable<PagedResponseKaizen> {
    const data = this.http.get<PagedResponseKaizen>(this.APIURL + '/Kaizen/SearchKaizens' + '?PageNumber=1&PageSize=55&criteria=' + criteria + '&ShowHidden=' + JSON.stringify(hidden) + '&Email=' + email);
    return data;
  }
 advancedSearchKaizens(
    beginningFiscalYear: number,
    endingFiscalYear: number | null,
    fields: string[],
    criteria: string
  ): Observable<any> {
    return this.http.post<any>(
      `${this.APIURL}/Kaizen/AdvancedSearch`,
      {
        beginningFiscalYear,
        endingFiscalYear,
        fields,
        criteria
      }
    );
  }
}